export function getContrastColor(hexColor: string) {
  hexColor = hexColor.replace('#', '')

  let r = 0
  let g = 0
  let b = 0

  if (hexColor.length === 3) {
    r = parseInt(hexColor.substring(0, 1) + hexColor.substring(0, 1), 16)
    g = parseInt(hexColor.substring(1, 2) + hexColor.substring(1, 2), 16)
    b = parseInt(hexColor.substring(2, 3) + hexColor.substring(2, 3), 16)
  } else if (hexColor.length === 6) {
    r = parseInt(hexColor.substring(0, 2), 16)
    g = parseInt(hexColor.substring(2, 4), 16)
    b = parseInt(hexColor.substring(4, 6), 16)
  }

  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 128 ? '#0f172a' : '#fff'
}

export function normalizeColor(color: string | undefined | null) {
  if (!color) return '#0070aa'
  if (color.startsWith('var')) return color

  return '#' + color.replace('#', '')
}
